import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import WarningIcon from '@material-ui/icons/Warning';
import IconButton from '@material-ui/core/IconButton';
import withStyles from '@material-ui/core/styles/withStyles';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import buildPathWithDealerGroup from 'components/TitlePage/components/buildPathWithDealerGroup';
import getImage from 'components/getImage';
import { useCheckVersion } from 'hooks/useCheckVersion';
import HeaderIcons from './components/HeaderIcons';
import * as S from './styles';

// Component import
import { ChatViewSwitch } from '../ChatViewSwitch';
import { Button } from '@material-ui/core';

const Header = props => {
  const { currentDealer, currentGroup } = useSelector(state => ({
    currentDealer: state.dealerStore.currentDealer,
    currentGroup: state.callCenter.currentGroup,
  }));

  const canSeeFullHeader = () => {
    const { isWithoutDealer, hiddeMenuAndHeaderItens } = props;
    if (isWithoutDealer || hiddeMenuAndHeaderItens) return false;
    return true;
  };

  const pathWithDealerGroup = buildPathWithDealerGroup();

  const getLinkImage = () => {
    if (currentDealer?.logo) {
      if (props?.logo?.imageId) {
        return getImage(
          { imageId: props.logo?.imageId, imageVcode: props.logo?.imageVcode },
          100,
          164,
          false,
          false,
          false,
          false,
          false,
          true
        );
      }
    }
    return null;
  };

  const logoUrl = getLinkImage();

  const onGroup = window.location.pathname.includes('group-view');
  const isCallCenter =
    props.groupTitle === 'Central de atendimento' &&
    window.location.pathname.includes('callcenter');

  const {
    icons,
    classes,
    open,
    history,
    isConsultantUser,
    hasResaleSellProduct,
    handleDrawerOpen,
    handleDrawerClose,
    hasMobioOneProduct,
  } = props;

  const isOutDated = useCheckVersion();

  return (
    <>
      <AppBar position="fixed" className={classNames(classes.appBar)}>
        <Grid container className={classes.grid}>
          {props.groupTitle && (
            <S.CallCenterLabel>
              {props.groupTitle}&nbsp;-&nbsp;
              <S.GroupLabel color="#fff">
                {pathWithDealerGroup[0]?.text ?? ''}
              </S.GroupLabel>
            </S.CallCenterLabel>
          )}
          {!props.hiddeMenuAndHeaderItens && (
            <>
              <div style={{ width: 70, textAlign: 'center' }}>
                {open ? (
                  <div className={classes.closeMenuBtn}>
                    <IconButton onClick={handleDrawerClose}>
                      <ChevronLeftIcon style={{ fill: '#fff' }} />
                    </IconButton>
                  </div>
                ) : (
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={handleDrawerOpen}
                    className={classNames(classes.menuButton, {
                      [classes.hide]: open,
                    })}
                  >
                    <MenuIcon style={{ fill: '#fff' }} />
                  </IconButton>
                )}
              </div>
              {currentDealer?.logo?.imageId &&
                (onGroup ? null : <S.ImgLogo src={logoUrl} alt="Logotipo" />)}
              <div>
                <S.GroupLabel color="#fff">
                  {onGroup
                    ? `${currentGroup?.name} (${currentGroup?.id})`
                    : `${currentDealer?.name} (${currentDealer?.id})`}
                </S.GroupLabel>
                {onGroup && (
                  <div
                    style={{
                      color: '#fff',
                      fontSize: 14,
                      lineHeight: '16px',
                      paddingLeft: 16,
                    }}
                  >
                    Painel gerencial
                  </div>
                )}
              </div>
            </>
          )}
          <Toolbar classes={{ root: classes.toolbar }}>
            {isCallCenter && <ChatViewSwitch />}

            <HeaderIcons
              isFullHeader={canSeeFullHeader}
              icons={onGroup ? [icons[1], icons[2], icons[3]] : icons}
              history={history}
              open={open}
              isConsultantUser={isConsultantUser}
              hasResaleProduct={hasResaleSellProduct}
              hasMobioOneProduct={hasMobioOneProduct}
            />
          </Toolbar>
        </Grid>
      </AppBar>
      {isOutDated && (
        <S.UpdateNotification>
          <WarningIcon />
          <p>Sua página parece estar desatualizada. Por favor, atualize-a!</p>
          <Button variant="outlined" onClick={() => window.location.reload()}>
            Atualizar
          </Button>
        </S.UpdateNotification>
      )}
    </>
  );
};

export default withStyles(S.styles, { withTheme: true })(Header);
